import { render, staticRenderFns } from "./RankItem.vue?vue&type=template&id=e0b6329a&"
import script from "./RankItem.vue?vue&type=script&lang=js&"
export * from "./RankItem.vue?vue&type=script&lang=js&"
import style0 from "./RankItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports